module.exports = __webpack_public_path__ + "image-b4ab7ff4129e.png";